import {useDispatch} from 'react-redux';

import {getLocalizationService} from '~/shared/services/localisationService';
import {generatePriceLabel} from '~/shared/components/PriceLabels';
import {getParsedDateDiff} from '~/shared/utils/dates';
import {setIsReorder} from '~/shared/store/actions';

import {
  ReorderItemWrapper,
  DetailsWrapper,
  LogoAndDetailsWrap,
  LogoWrap,
  Logo,
  RestaurantName,
  OrderDate,
  PreviewButton,
  OrderButton,
  ScreenReaderNotificator,
  ContentWrapper,
  DetailsAndOrderButtonWrapper,
} from '../../dropdown.styled';

const ReorderItem = ({orderId, restaurant, date, price, handleOnReorderClick, handleOnPreviewClick, isPage}) => {
  const {t} = getLocalizationService();

  const parsedDate = getParsedDateDiff(date);
  const dispatch = useDispatch();

  const onPreviewButtonClicked = () => {
    handleOnPreviewClick({orderId, restaurantId: restaurant.id});
  };

  const onOrderButtonClicked = () => {
    dispatch(setIsReorder(true));
    handleOnReorderClick({orderId, restaurantId: restaurant.id});
  };

  return (
    <>
      <ScreenReaderNotificator>
        `${restaurant.name} ${parsedDate} ${generatePriceLabel(price)}`
      </ScreenReaderNotificator>

      <ReorderItemWrapper isPage={isPage}>
        <LogoAndDetailsWrap>
          <LogoWrap>
            <Logo src={restaurant.logoUrl} alt={restaurant.name} />
          </LogoWrap>
          <ContentWrapper>
            <RestaurantName>{t(restaurant.name)}</RestaurantName>
            <DetailsAndOrderButtonWrapper>
              <DetailsWrapper>
                <OrderDate>{parsedDate}</OrderDate>
                <PreviewButton onClick={onPreviewButtonClicked}>{t('preview_order')}</PreviewButton>
              </DetailsWrapper>
              <OrderButton onClick={onOrderButtonClicked}>{t('order_again')}</OrderButton>
            </DetailsAndOrderButtonWrapper>
          </ContentWrapper>
        </LogoAndDetailsWrap>

      </ReorderItemWrapper>
    </>
  );
};

export default ReorderItem;
